import React from 'react';
import { X, Check, Frown, Smile } from 'lucide-react';
const BEFORE_ITEMS = ['Cancelas planes a último momento inventando excusas', 'Repasas cada conversación buscando errores por horas', 'Tu corazón se acelera solo de pensar en una reunión', 'Evitas llamadas telefónicas aunque sean importantes', 'Te sientes agotado/a después de cualquier interacción social', 'Sientes que todos te están juzgando constantemente', 'Duermes mal porque tu mente no para de procesar'];
const AFTER_ITEMS = ['Llegas a eventos sociales sintiéndote en control', 'Las conversaciones fluyen sin el replay mental después', 'Tu cuerpo se mantiene calmado incluso bajo presión', 'Haces llamadas y hablas en reuniones con naturalidad', 'Terminas el día con energía, no destruido/a', 'Dejas de preocuparte por lo que piensan los demás', 'Duermes tranquilo/a sin el sobrepensamiento nocturno'];
export function BeforeAfter() {
  return <section className="py-12 bg-cream" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-charcoal text-center mb-12" data-id="element-3">
          ¿Te identificas con esto?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4">
          {/* BEFORE */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border-t-8 border-red-500 relative overflow-hidden" data-id="element-5">
            <div className="absolute -right-4 -top-4 opacity-5" data-id="element-6">
              <Frown className="w-48 h-48" data-id="element-7" />
            </div>
            <div className="relative z-10" data-id="element-8">
              <div className="flex items-center mb-8" data-id="element-9">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4" data-id="element-10">
                  <Frown className="w-6 h-6 text-red-600" data-id="element-11" />
                </div>
                <h3 className="text-2xl font-heading font-bold text-charcoal" data-id="element-12">
                  Síntomas de ansiedad social:
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-13">
                {BEFORE_ITEMS.map((item, i) => <li key={i} className="flex items-start bg-red-50/50 p-3 rounded-xl" data-id="element-14">
                    <X className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-15" />
                    <span className="text-charcoal/80 font-medium" data-id="element-16">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* AFTER */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border-t-8 border-sage relative overflow-hidden" data-id="element-17">
            <div className="absolute -right-4 -top-4 opacity-5" data-id="element-18">
              <Smile className="w-48 h-48" data-id="element-19" />
            </div>
            <div className="relative z-10" data-id="element-20">
              <div className="flex items-center mb-8" data-id="element-21">
                <div className="w-12 h-12 bg-sage/20 rounded-full flex items-center justify-center mr-4" data-id="element-22">
                  <Check className="w-6 h-6 text-sage" data-id="element-23" />
                </div>
                <h3 className="text-2xl font-heading font-bold text-charcoal" data-id="element-24">
                  DESPUÉS del Protocolo
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-25">
                {AFTER_ITEMS.map((item, i) => <li key={i} className="flex items-start bg-sage/10 p-3 rounded-xl" data-id="element-26">
                    <Check className="w-5 h-5 text-sage mt-0.5 mr-3 flex-shrink-0" data-id="element-27" />
                    <span className="text-charcoal/80 font-medium" data-id="element-28">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}